import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        salutation: null,
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        errors: {},
        packingStation: null,
        packingStationPostCode: null,
        fiscalCode: null,
    },
    getters: {
        getSalutation: state => state.salutation,
        getFirstName: state => state.firstName,
        getLastName: state => state.lastName,
        getEmail: state => state.email,
        getPassword: state => state.password,
        getPackingStation: state => state.packingStation,
        getPackingStationPostCode: state => state.packingStationPostCode,
        getFiscalCode: state => state.fiscalCode,
    },
    mutations: {
        setSalutation(state, value) {
            state.salutation = value;
        },
        setFirstName(state, value) {
            state.firstName = value;
        },
        setLastName(state, value) {
            state.lastName = value;
        },
        setEmail(state, value) {
            state.email = value;
        },
        setPassword(state, value) {
            state.password = value;
        },
        setPackingStation(state, value) {
            state.packingStation = value;
        },
        setPackingStationPostCode(state, value) {
            state.packingStationPostCode = value;
        },
        setFiscalCode(state, value) {
            state.fiscalCode = value;
        },
        setErrors(state, errors) {
            for (let field of Object.keys(errors)) {
                Vue.set(state.errors, field, errors[field]);
            }
        },
        resetErrors(state, field) {
            if (field && state.errors[field]) {
                delete state.errors[field];
            } else {
                state.errors = {};
            }
        },
    },
};
